import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
    class: "min-h-5 text-sm text-(--colors-text-body-subtle)",
    "data-testid": "tax-receipts-subtitle"
};
const _hoisted_2 = ["aria-label"];
import { Breadcrumb, Button, ButtonGroup, DetailHeaderWrapper } from "@eudonet/opal";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { RouterLink, useRoute, useRouter } from "vue-router";
import { usePermissions } from "@/shared/composables/usePermissions";
import { activeTaxReceiptsTab, TAX_RECEIPTS_HEADER_TAB_KEYS, TAX_RECEIPTS_TAB_BY_KEY, TAX_RECEIPTS_TABS, } from "../../composables/taxReceiptsTabs";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TaxReceiptsPageHeader',
    props: {
        subtitle: {}
    },
    setup(__props) {
        const { t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const { can } = usePermissions();
        // Same gate as the route behind each tab: a reader never sees a tab the guard would refuse.
        const visibleTabs = computed(() => TAX_RECEIPTS_TABS.filter((tab) => TAX_RECEIPTS_HEADER_TAB_KEYS.includes(tab.key) && can(tab.requiresCapability)));
        // The area label links to the dashboard only once that screen is delivered: until then the link
        // would lead into the empty placeholder.
        const dashboardDelivered = TAX_RECEIPTS_HEADER_TAB_KEYS.includes("dashboard");
        const activeTab = computed(() => activeTaxReceiptsTab(route.path));
        const screenLabel = computed(() => {
            const tab = TAX_RECEIPTS_TABS.find((candidate) => candidate.key === activeTab.value);
            return tab ? t(tab.labelKey) : "";
        });
        const breadcrumbItems = computed(() => [
            {
                label: t("finance.taxReceipts.title"),
                to: dashboardDelivered ? { name: TAX_RECEIPTS_TAB_BY_KEY.dashboard.routeName } : undefined,
            },
            { label: screenLabel.value },
        ]);
        // "Paramètres · Reçus fiscaux": the screen first, the area second, like the prototype.
        const pageTitle = computed(() => screenLabel.value ? t("finance.taxReceipts.pageTitle", { screen: screenLabel.value }) : t("finance.taxReceipts.title"));
        // A plain push: the page being left owns its unsaved-changes guard (onBeforeRouteLeave), so a
        // refused navigation simply keeps the current tab active.
        function goTo(tab) {
            if (tab.key === activeTab.value)
                return;
            void router.push({ name: tab.routeName });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(DetailHeaderWrapper), {
                title: pageTitle.value,
                class: "mb-2"
            }, _createSlots({
                topbar: _withCtx(() => [
                    _createVNode(_unref(Breadcrumb), {
                        class: "pb-2",
                        items: breadcrumbItems.value,
                        ariaLabel: _ctx.$t('finance.taxReceipts.breadcrumbLabel'),
                        "link-as": _unref(RouterLink),
                        "data-testid": "tax-receipts-breadcrumb"
                    }, null, 8 /* PROPS */, ["items", "ariaLabel", "link-as"])
                ]),
                facets: _withCtx(() => [
                    _createElementVNode("p", _hoisted_1, _toDisplayString(__props.subtitle), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
            }, [
                (_ctx.$slots.actions)
                    ? {
                        name: "actions",
                        fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "actions")
                        ]),
                        key: "0"
                    }
                    : undefined,
                (visibleTabs.value.length > 0)
                    ? {
                        name: "tabs",
                        fn: _withCtx(() => [
                            _createElementVNode("nav", {
                                "aria-label": _ctx.$t('finance.taxReceipts.tabsLabel')
                            }, [
                                _createVNode(_unref(ButtonGroup), {
                                    "overflow-label": _ctx.$t('common.tabs.next'),
                                    "overflow-previous-label": _ctx.$t('common.tabs.previous')
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleTabs.value, (tab) => {
                                            return (_openBlock(), _createBlock(_unref(Button), {
                                                key: tab.key,
                                                variant: "tertiary",
                                                label: _ctx.$t(tab.labelKey),
                                                active: tab.key === activeTab.value,
                                                "aria-current": tab.key === activeTab.value ? 'page' : undefined,
                                                "data-testid": `tax-receipts-tab-${tab.key}`,
                                                onClick: ($event) => (goTo(tab))
                                            }, null, 8 /* PROPS */, ["label", "active", "aria-current", "data-testid", "onClick"]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["overflow-label", "overflow-previous-label"])
                            ], 8 /* PROPS */, _hoisted_2)
                        ]),
                        key: "1"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]));
        };
    }
});
